import React, { useEffect, useState } from 'react';
import Content from '../../../layout/content/Content';
import Head from '../../../layout/head/Head';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Icon } from '../../../components/Component';
import { useDispatch } from 'react-redux';
import CardTabs from '../../components/cards/CardTabs';
import MainProductsValuation from './data/MainProductsValuation';

const ProductsValuation = ({ tenant_info, user_info }) => {

 const [activeCardTab, setActiveCardTab] = useState("Main Info");

 // Card Tabs
 const tabs = [
  {
   tabName: "Main Info"
  },
  {
   // tabName: "Analytics"
  }
 ];

 return (
  <>
   <Head title={tenant_info?.name ? `${tenant_info.name} Products Valuation` : "Products Valuation"} />
   <Content>
    <BlockHead size="sm">
     <BlockHeadContent>
      <BlockTitle>Products Valuation</BlockTitle>
     </BlockHeadContent>
    </BlockHead>
    <Block>
     <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
     {
      activeCardTab === "Main Info" && (
       <MainProductsValuation tenant_info={tenant_info} user_info={user_info} />
      )
     }
    </Block>
   </Content>
  </>
 );
};

export default ProductsValuation;